import Response from "../../Data/Domain/Response";
import EmissionCategory from "../Domain/EmissionCategory";
import { getEmissionCategory } from "./EmissionCategory.service";

export async function getEmissionCategoryRepository() {
  const data = await getEmissionCategory();
  return new Response(data, EmissionCategory).getMultiple();
}
